import { Badge as UiBadge } from "@jesus-central-church/ui";
import { SbBlokData, storyblokEditable } from "@storyblok/react/rsc";
import { SbBadge } from "@storyblok/types/287435740670216/storyblok-components";

export function BadgeComponent({ blok }: { blok: SbBadge }) {
  return (
    <UiBadge
      link={blok.link?.url}
      text={blok.text}
      textColor={blok.textColor}
      backgroundColor={blok.backgroundColor}
      {...storyblokEditable(blok as SbBlokData)}
    />
  );
}
